import type { GoalFormSchema } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm.types'

import type { GoalData } from '@/__generated__/requests'

export function goalFormDefaultValues(data?: GoalData): GoalFormSchema {
  return {
    amount: data?.amount ?? 0,
    dueDate: data?.dueDate ?? '',
    monthlyReminder: data?.monthlyReminder ?? false,
    monthlyReminderAmount: data?.monthlyReminderAmount ?? undefined,
    name: data?.name ?? '',
    startDate: data?.startDate ?? '',
  }
}
